import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { PendingSubscriptionOffer } from './use-subscription-offer';

// tenant: global — resolves the offer addressed to the signed-in user's email; no
// companies/:companyId exists yet to scope by (the claim is what creates the company). Imperative
// (mutation-shaped) because it runs once inside auth flows, as the server-side fallback when the
// browser-local offer state is missing (e.g. the verification email was opened on another device).
export const useResolvePendingSubscriptionOffer = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: resolvePendingSubscriptionOffer } = useAppMutation<
    null | PendingSubscriptionOffer,
    unknown,
    void
  >([QueryKey.GET_PENDING_SUBSCRIPTION_OFFER], {
    mutationFn: () =>
      ApiService.get<null | PendingSubscriptionOffer>({
        endpoint: BackendRoute.SUBSCRIPTION_OFFERS,
        routePath: ['pending'],
      }),
    onSuccess: (pendingOffer) => {
      if (!pendingOffer) return;
      // The guard/billing flow reads the public offer next — make sure it is fresh.
      void queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_SUBSCRIPTION_OFFER, pendingOffer.slug],
      });
    },
    // Callers fall back to the normal flow on failure — no user-facing error for a lookup.
    defaultErrorHandling: false,
  });

  return { resolvePendingSubscriptionOffer };
};
